<template lang="html">
  <div class="login-header" :class="{ 'is-fullscreen': isFullscreen }">
    <div class="login-header__wrapper">
      <div class="login-header__logo">
        <a :href="vcv_link">
          <img src="/static/images/logo.svg" />
        </a>
      </div>
      <a v-if="is_reg" href="#" class="login-header__registration" @click.prevent="go_to_link">
        {{ router_label }}
      </a>
    </div>
  </div>
</template>

<script>
  export default {
    name: 'vheader',
    props: {
      is_reg: {
        type: Boolean,
        default: true
      },
      isFullscreen: {
        type: Boolean,
        default: false
      }
    },
    computed: {
      form_path() {
        if (this.registration_form) {
          return '/login';
        } else {
          return `/registration/${this.locale}`;
        }
      },

      registration_form() {
        return this.$route.name ? this.$route.name === 'registration' : false;
      },

      router_label() {
        if (this.registration_form) {
          return this.$tr('login.submit');
        } else {
          return this.$tr('pageTitles.routes.registration');
        }
      },

      locale() {
        return this.$store.getters['locale/current'];
      },

      domain() {
        return this.$store.getters['services/domain'];
      },

      vcv_link() {
        if (this.domain === 'ru') {
          return 'https://vcv.ru';
        } else if (this.domain === 'jp') {
          return 'https://vcv.co.jp';
        } else {
          return 'https://vcv.ai';
        }
      }
    },
    methods: {
      go_to_link() {
        window.location = this.form_path;
      }
    }
  };
</script>

<style lang="scss" scoped>
@import '@/styles/variables.scss';

.login-header {
  width: 100%;
  border-bottom: 1px solid #d2d6e0;
  padding: 12px 0;
  display: flex;
  justify-content: center;

  &__wrapper {
    max-width: 1200px;
    min-width: 1200px;
    display: flex;
    align-items: center;
    justify-content: space-between;
    box-sizing: border-box;
  }

  &.is-fullscreen {
    padding: 12px 24px;
    box-sizing: border-box;

    .login-header__wrapper {
      max-width: none;
      min-width: auto;
      flex: 1;
    }
  }

  &__logo img {
    display: block;
    width: 100px;
  }

  &__registration {
    font-weight: 500;
    font-size: 15px;
    line-height: 22px;
    letter-spacing: 0.005em;
    color: $green;
  }
}

@media (max-width: 1240px) {
  .login-header {
    &__wrapper {
      max-width: 100%;
      min-width: 100%;
      padding: 0 50px;
    }
  }
}
@media (max-width: 840px) {
  .login-header {
    &__wrapper {
      max-width: 100%;
      min-width: 100%;
      padding: 0 20px;
    }
  }
}
</style>
